var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubscriptionIcon = function SvgSubscriptionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M6.544 19.203A4.1 4.1 0 0 0 9.62 19.2l2.144-.88a1.3 1.3 0 0 1 1.04.03l.758.367a1.69 1.69 0 0 0 1.644-.096c.498-.314.795-.855.794-1.445l-.01-12.26C15.99 2.193 14.355.5 11.724.5H4.425C1.768.499.182 2.15.182 4.917l-.018 12.26a1.69 1.69 0 0 0 .801 1.445 1.69 1.69 0 0 0 1.637.087l.75-.357a1.32 1.32 0 0 1 1.043-.03zm3.902-6.005H5.338a.75.75 0 0 1 0-1.5h5.108a.75.75 0 0 1 0 1.5M6.76 9.908a.746.746 0 0 0 1.06 0l3.157-3.16a.75.75 0 0 0-1.061-1.06L7.289 8.317 6.278 7.308a.749.749 0 1 0-1.06 1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgSubscriptionIcon;